import { matchPaymentDetailsPagePath, ROUTES } from '@futrli/shared-services';
import { Location } from 'history';
import { get } from 'lodash';
import { NavigateFunction } from 'react-router-dom';

const HIDE_APP_NAV_BAR = 'HIDE_APP_NAV_BAR';

/**
 * Determine if we should hide the nav on the current route.
 *
 * @param {Location} location
 * @returns {boolean}
 */
export const shouldHideNav = (location: Location): boolean => {
  return (
    location.pathname.includes(ROUTES.MY_PROFILE) ||
    location.pathname.includes(ROUTES.IMPORT) ||
    location.pathname.includes(ROUTES.CREATE_CONSOLIDATION) ||
    matchPaymentDetailsPagePath(location.pathname) ||
    getHideAppNavBarFromLocationState(location)
  );
};

export const getHideAppNavBarFromLocationState = (location: Location): boolean => {
  return get(location, ['state', HIDE_APP_NAV_BAR], false);
};

/**
 * Redirect to the same location, but modifies the state and adds HIDE_APP_NAV_BAR flag
 * to notify the app nav bar has to be hidden.
 * @param {History} history
 * @param {Location} location
 */
export const hideAppNavBarWithLocationState = (navigate: NavigateFunction, location: Location) => {
  // Checks the location state, if it has HIDE_APP_NAV_BAR set to true, then does nothing.
  if (getHideAppNavBarFromLocationState(location)) {
    return;
  }

  const locationState = typeof location.state === 'object' ? location.state : {};

  navigate(`${location.pathname}${location.search || ''}${location.hash || ''}`, {
    replace: true,
    state: {
      ...locationState,
      [HIDE_APP_NAV_BAR]: true
    }
  });
};
